import { z } from 'zod'

/** API `processing_status` values (backend contract). */
export enum UserFileProcessingStatus {
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

/** Client-safe reasons a non-terminal file has not advanced. */
export enum UserFileProcessingBlockedReason {
  OcrQuota = 'OCR_QUOTA',
}

/** Forward-compatible runtime schema. UI behavior compares known reasons explicitly. */
export const FileProcessingBlockedReasonSchema = z.string().nullish()

/**
 * Forward-compatible runtime schema. Backend may add statuses over time.
 */
export const FileProcessingStatusSchema = z.string()

export type FileProcessingStatus = z.infer<typeof FileProcessingStatusSchema>
